import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store.js'
import Login from '@/views/auth/Login'
import Signup from '@/views/auth/Signup'
import Upgrade from '@/views/auth/Upgrade'
import SignupShared from '@/views/auth/SignupShared'
import ResetPassword from '@/views/auth/ResetPassword'
import ConfirmResetPassword from '@/views/auth/ConfirmResetPassword'
import Home from '@/views/Home'
import Catalog from '@/views/catalog/Catalog'
import CatalogCategories from '@/views/catalog/CatalogCategories'
import SelectedCatalogItem from '@/views/catalog/SelectedCatalogItem'
import Profile from '@/views/settings/Profile'
import Account from '@/views/settings/Account'
import Settings from '@/views/settings/Settings'
import UseCatagory from '@/views/uses/UseCatagory'
import Uses from '@/views/uses/Uses'
import Checkout from '@/views/Checkout'
import Contacts from '@/views/contacts/Contacts'
import SelectedContact from '@/views/contacts/SelectedContact'
import CreateContact from '@/views/contacts/CreateContact'
import RecipeCategory from '@/views/recipes/RecipeCategory'
import Recipe from '@/views/recipes/Recipe'

Vue.use(Router)

const signupParamsCheck = (to, from, next) => {
  if (to.query.subscription) {
    store.commit('SET_SIGNUP_PARAMS', to.query)
  } else if (to.query.success) {
    store.commit('SET_ACCESS_REFRESH')
    store.dispatch('signUpSucess')
  }
  next()
}

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/signupshare',
      name: 'Signup Share',
      component: SignupShared
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      beforeEnter: signupParamsCheck
    },
    {
      path: '/reset',
      name: 'Reset Password',
      component: ResetPassword
    },
    {
      path: '/reset-password',
      name: 'Confirm Reset',
      component: ConfirmResetPassword
    },
    {
      path: '/upgrade',
      name: 'Upgrade',
      component: Upgrade,
      beforeEnter: signupParamsCheck
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/catalog/',
      name: 'Catalog',
      component: CatalogCategories,
      props: true
    },
    {
      path: '/catalog/:type',
      name: 'Catalog Items',
      component: Catalog,
      props: true,
      children: [
        {
          path: ':itemId',
          component: SelectedCatalogItem,
          props: true
        }
      ]
    },

    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/useCatagories',
      name: 'Uses and Recipes',
      component: UseCatagory
    },
    {
      path: '/useCatagories/:useId',
      name: 'Uses',
      component: Uses,
      props: true,
      children: [
        {
          path: ':categoryId',
          component: RecipeCategory,
          props: true
        }
      ]
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts,
      children: [
        {
          path: ':contactId',
          name: 'Contact',
          component: SelectedContact,
          props: true
        }
      ]
    },
    {
      path: '/createContact/:type?',
      name: 'Create Contact',
      component: CreateContact,
      props: true
    },
    {
      path: '/uses/:categoryId?',
      name: 'Recipe Category',
      component: RecipeCategory,
      props: true
    },
    {
      path: '/recipe',
      name: 'Recipe',
      component: Recipe,
      props: true
    }
  ]
})

router.beforeEach((to, from, next) => {
  //will have to check user.MentorName to know if they have payed the first time. Might have to check something else later.
  //signupshare?m=mentorcode4cf4f
  const isLoggedIn = store.getters.user
  const isNotToAuthPage =
    to.name !== 'Login' &&
    to.name !== 'Signup' &&
    to.name !== 'Signup Share' &&
    to.name !== 'Upgrade' &&
    to.name !== 'Reset Password' &&
    to.name !== 'Confirm Reset'
  // const isNotPaid =
  //   store.getters.subscriptionStatus &&
  //   store.getters.subscriptionStatus.Status === 0
  // const isNotCheckout = to.name !== 'Checkout' && isNotToAuthPage
  if (isNotToAuthPage && !isLoggedIn) {
    let now = new Date()
    const isAuth =
      store.getters.access.token && now < store.getters.access.expires
    if (isAuth) {
      store.commit('SET_ACCESS_REFRESH')
      store
        .dispatch('getUser')
        .then(() => {
          store.dispatch('getAllData')
          next()
        })
        .catch(() => store.commit('ERROR_LOGOUT'))
    } else {
      next({
        name: 'Login'
      })
    }
    // } else if (isNotCheckout && isNotPaid) {
    //   next({ name: 'Checkout' })
  } else {
    next()
  }
})
export default router
